import { PUBLIC_CMS_TOKEN, PUBLIC_CMS_API_URL } from '$env/static/public'

export function ContentManagerSystem<V = unknown>(query: string) {
  return async (variables?: V) => {
    const headers = { Authorization: `Barear ${PUBLIC_CMS_TOKEN}` }

    const payload = {
      headers,
      method: 'POST',
      body: JSON.stringify({ query, variables }),
    }

    const request = await fetch(PUBLIC_CMS_API_URL, payload)
      .then((r) => r.json())
      .then((r) => r)
      .catch(console.error)

    return request.data
  }
}
